import requestCtxs from '@/sealFilter/requestCtxs'

//书架数据
export function bookshelfList (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/bookshelf/query/by/condition',
        method: 'post',
        data
    })
}
// 加入书架
export function addBookshelf (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/bookshelf/add',
        method: 'post',
        data
    })
}
// 删除书架数据
export function deleteByid (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/bookshelf/delete/byid',
        method: 'post',
        data
    })
}

 //我的书架列表
export function myShelf (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/book/shelf/info/query/by/condition',
        method: 'post',
        data
    })
}
//书架详情
export function shelfInfo (data) {
   return requestCtxs({
       url: '/portal/ttv3/portal/book/shelf/info/query/by/id',
       method: 'post',
       data
   })
}

//新增书架名称
export function createShelf(data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/book/shelf/info/add',
        method: 'post',
        data
    })
 }
 //修改书架名称
 export function updateShelf (data) {
     return requestCtxs({
         url: '/portal/ttv3/portal/book/shelf/info/update/byid',
         method: 'post',
         data
     })
  }
  //删除书架
 export function removeShelf (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/book/shelf/info/delete/byid',
        method: 'post',
        data
    })
 }
 //移动书目到其它书架
 export function moveToOther (data) {
     return requestCtxs({
         url: '/portal/ttv3/portal/user/bookshelf/update/byid',
         method: 'post',
         data
     })
  }
  //导入
  export function uploadShelf (data) {
      return requestCtxs({
          url: '/portal/ttv3/portal/user/bookshelf/import',
          method: 'post',
          data
      })
   }


// WEBPACK FOOTER //
// ./src/api/bookshelf.js